export enum DataHooks {
  SPINNER = 'button-spinner',
}

export enum ButtonVariant {
  FILLED = 'filled',
  OUTLINED = 'outlined',
}
